// 2026-09-21 - FormuLearning - 용출 용액 키·f2 사유 문구 공용 (이슈 #69 S6)
// 파일 위치: frontend/src/lib/dissolution.ts
// 목적: 용출 비교 그래프·f2 추이 그래프·용출 입력표가 같은 용액 키 규칙과 f2 사유 문구를
//       쓰게 한 자리로 모은다. 종전 `solutionKey` 는 `DissolutionCompareChart` 에, 사유
//       문구는 `DissolutionGrid` 에 따로 있었다. f2 **판정**(≥50 유사)은 서버가 내려준다
//       (`app/lot/f2.py` `judge_by_solution`) — 화면에서 다시 판정하지 않는다.

/**
 * 용액(pH) 식별자 정규화 — 백엔드 `f2.solution_key()`와 같은 규칙(#60, M84-20).
 * 대조약은 `"1.2"`, 시험약은 `"pH 1.2"`처럼 표기가 갈릴 수 있다. 'pH 6.8' / '6.80' / 6.8
 * 을 같은 키로 본다. `f2_by_solution` 의 키도 이 형태다(`"1.2"`·`"4"`·`"6.8"`).
 */
export const solutionKey = (raw: unknown): string => {
  if (raw == null) return ''
  const text = String(raw).trim()
  const n = Number(text.toLowerCase().replace(/ph/g, '').trim())
  return Number.isFinite(n) && text !== '' ? String(n) : text
}

/** 화면 표기 — 숫자 키는 소수 한 자리(`"4"` → `pH 4.0`), 그 밖은 그대로. */
export const solutionLabel = (key: string): string => {
  const n = Number(key)
  return key !== '' && Number.isFinite(n) ? `pH ${n.toFixed(1)}` : key
}

/** 용액 키 정렬 — 숫자 pH 오름차순, 숫자가 아닌 키는 뒤로. 색 배정 순서가 이 순서다. */
export const compareSolutionKeys = (a: string, b: string): number => {
  const na = Number(a)
  const nb = Number(b)
  const fa = a !== '' && Number.isFinite(na)
  const fb = b !== '' && Number.isFinite(nb)
  if (fa && fb) return na - nb
  if (fa !== fb) return fa ? -1 : 1
  return a.localeCompare(b)
}

/** f2 계산 불가 사유 코드(backend `app/lot/f2.py`)의 화면 문구. */
export const F2_REASON_TEXT: Record<string, string> = {
  no_reference: 'No reference profile — enter the reference drug dissolution first',
  no_test: 'No test profile entered',
  no_common_solution: 'No pH shared with the reference profile',
  no_overlap: 'Time range does not overlap the reference',
  insufficient_points: 'Needs at least 3 valid time points',
  excluded: 'Excluded batch — f2 is not assigned',
}
